// @ts-ignore
import buildColor from "@fdr/static-ui/ColorPalette";

export type ElevationLevel = {
  [elevation in "low" | "mid" | "high"]: string;
};

export const elevations: ElevationLevel = {
  low: `0px 1px 4px ${buildColor("black", "25")}`,
  mid: `0px 1px 8px ${buildColor("black", "25")}`,
  high: `0px 1px 16px ${buildColor("black", "25")}`
};
